export default __webpack_public_path__ + "static/media/diners.16ee6f00.svg";